module.exports = __webpack_public_path__ + "img/DE00213.3bc9c541.png";